import React from 'react';

import { AccordionBlockProps } from '@/app/_blocks/AccordionBlockGraphQL/types';
import SemanticHeading, { SemanticHeadingData } from '../SemanticHeading';

import classes from './AccordionBlock.module.scss';
import { Gutter } from '../Gutter';
import { renderTrademarkText } from '../TrademarkText';

export const AccordionBlock: React.FC<{
  className?: string;
  accordionBlock: AccordionBlockProps;
}> = ({ className, accordionBlock }) => {
  const twoColumns = accordionBlock.twoColumns;
  const extraClass = twoColumns ? classes.twoColumns : '';
  const design = accordionBlock.design;
  return (
    <Gutter>
      <div className={[className, classes.wrapper, extraClass, 'grid', design === 'grayBox' ? classes.grayBoxDesign : ''].filter(Boolean).join(' ')}>
        <div className="col-12">
          {(() => {
            const headlineText = accordionBlock.accordionHeadline?.text || accordionBlock.headline_legacy;
            const headlineTag = accordionBlock.accordionHeadline?.tag || 'h2';
            const HeadlineTag = headlineTag as 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
            return headlineText ? <HeadlineTag className='heading-h2'>{headlineText}</HeadlineTag> : null;
          })()}
        </div>
        {accordionBlock.items.map((item, index) => (
          <details key={item.id} className={twoColumns ? 'col-6 col-sm-12' : 'col-12'}>
            <summary id={`accordion-${item.id}-label`} className={classes.accordionLabel}>
              <SemanticHeading
                heading={item.accordionItemTitle as SemanticHeadingData}
                fallbackText={item.title_legacy || ''}
                fallbackTag='h3'
              />
            </summary>
            <div className={classes.accordionContent}>
              <p>{item.content ? renderTrademarkText(item.content) : null}</p>
            </div>
          </details>
        ))}
      </div>
    </Gutter>
  );
};

export default AccordionBlock;
